const PREFIX = "onecall_";

function key(name: string): string { return PREFIX + name; }

export const storage = {
  get<T = string>(name: string): T | null {
    try { const raw = localStorage.getItem(key(name)); return raw === null ? null : JSON.parse(raw) as T; } catch { return null; }
  },
  set<T = string>(name: string, value: T): void {
    try { localStorage.setItem(key(name), JSON.stringify(value)); } catch { /* ignore */ }
  },
  remove(name: string): void { try { localStorage.removeItem(key(name)); } catch { /* ignore */ } },
  getPhone(): string { return this.get<string>("phone") || ""; },
  setPhone(phone: string): void { this.set("phone", phone); },
  getCountryCode(): string { return this.get<string>("countryCode") || "CN"; },
  setCountryCode(code: string): void { this.set("countryCode", code); },
};
